import React from 'react';
import ReactDOM from 'react-dom';
import MapModule from './map';

const renderRoots = document.querySelectorAll('.smart-map');
for (let i = 0; i < renderRoots.length; ++i) {
	const data = renderRoots[i].dataset;
	setTimeout(() => {
		ReactDOM.render(
			<MapModule types_to_exclude={JSON.parse(data.excludeType)} />,
        renderRoots[i]
    );
  }, 1000);
}
